export default __webpack_public_path__ + "static/media/metamask.872a6ec4.svg";